import type { ReactNode } from "react";
import { Header } from "./Header";
import { CategoryHero } from "./CategoryHero";
import { BankMarquee } from "./BankMarquee";
import { CompareList } from "./CompareList";
import { CostDisclosure } from "./CostDisclosure";
import { Footer, StickyMobileBar } from "./Footer";
import { LoanGuideContent } from "./LoanGuideContent";
import { FaqSection, PAGE_FAQ } from "./PageFaq";
import { getFeaturedForPage, DEFAULT_AMOUNT, type FilterKey, type PageKey } from "@/lib/lenderSelection";
import { useCurrentMonth } from "@/lib/useCurrentMonth";
import { EpiProvider } from "@/lib/epi";

export type CategoryPageProps = {
  page: PageKey;
  productLabel: string;
  headingBefore: string;
  underlined: string;
  headingAfter: string;
  subtitle: ReactNode;
  featuredTitleTemplate?: (month: string) => string;
  lockedFilter?: FilterKey;
  /** Extra redaktionellt innehåll som visas direkt under topplistan. */
  belowList?: ReactNode;
  /** Visar obligatorisk kostnadsinformation (Google Ads privatlånspolicy) ovanför topplistan. */
  showCostDisclosure?: boolean;
};


export function LoanCategoryPage(cfg: CategoryPageProps) {
  const { month } = useCurrentMonth();
  const featured = getFeaturedForPage(cfg.page, DEFAULT_AMOUNT[cfg.page]);
  const featuredTitle = cfg.featuredTitleTemplate
    ? cfg.featuredTitleTemplate(month)
    : `Toppval för snabba utbetalningar i ${month}`;

  return (
    <EpiProvider value={cfg.page}>
      <div className="min-h-screen">
      <Header />
      <main>
        <CategoryHero
          headingBefore={cfg.headingBefore}
          underlined={cfg.underlined}
          headingAfter={cfg.headingAfter}
          subtitle={cfg.subtitle}
          featuredLender={featured}
          featuredTitle={featuredTitle}
          featuredTitleHighlight={month}
          topListId="toplist"
        />
        <BankMarquee />
        <CompareList
          page={cfg.page}
          productLabel={cfg.productLabel}
          id="toplist"
          lockedFilter={cfg.lockedFilter}
        />
        {cfg.showCostDisclosure && <CostDisclosure page={cfg.page} />}
        {cfg.belowList}
        <LoanGuideContent page={cfg.page} productLabel={cfg.productLabel} />
        <FaqSection items={PAGE_FAQ[cfg.page]} />
      </main>

      <Footer />
      <StickyMobileBar lender={featured} product={cfg.productLabel.toLowerCase()} />
      </div>
    </EpiProvider>
  );
}
